/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreorderPropertyInfoDto } from './preorder-property-info-dto';
import {
    PreorderPropertyInfoDtoFromJSON,
    PreorderPropertyInfoDtoFromJSONTyped,
    PreorderPropertyInfoDtoToJSON,
    PreorderPropertyInfoDtoToJSONTyped,
} from './preorder-property-info-dto';
import type { PreorderPriceInfoDto } from './preorder-price-info-dto';
import {
    PreorderPriceInfoDtoFromJSON,
    PreorderPriceInfoDtoFromJSONTyped,
    PreorderPriceInfoDtoToJSON,
    PreorderPriceInfoDtoToJSONTyped,
} from './preorder-price-info-dto';
import type { ContactsInfoModel } from './contacts-info-model';
import {
    ContactsInfoModelFromJSON,
    ContactsInfoModelFromJSONTyped,
    ContactsInfoModelToJSON,
    ContactsInfoModelToJSONTyped,
} from './contacts-info-model';
import type { AdditionalServiceInfoDto } from './additional-service-info-dto';
import {
    AdditionalServiceInfoDtoFromJSON,
    AdditionalServiceInfoDtoFromJSONTyped,
    AdditionalServiceInfoDtoToJSON,
    AdditionalServiceInfoDtoToJSONTyped,
} from './additional-service-info-dto';
import type { PreorderRoomInfoDto } from './preorder-room-info-dto';
import {
    PreorderRoomInfoDtoFromJSON,
    PreorderRoomInfoDtoFromJSONTyped,
    PreorderRoomInfoDtoToJSON,
    PreorderRoomInfoDtoToJSONTyped,
} from './preorder-room-info-dto';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';

/**
 * 
 * @export
 * @interface PreorderBookingDetailsInfoResponseDto
 */
export interface PreorderBookingDetailsInfoResponseDto {
    /**
     * 
     * @type {ContactsInfoModel}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    contactInfo?: ContactsInfoModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    placementCodes: Array<string>;
    /**
     * 
     * @type {PreorderPropertyInfoDto}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    propertyInfo: PreorderPropertyInfoDto;
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    bookingInfo: TravelineBookingStayDatesDto;
    /**
     * 
     * @type {PreorderRoomInfoDto}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    roomInfo: PreorderRoomInfoDto;
    /**
     * 
     * @type {PreorderPriceInfoDto}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    priceInfo: PreorderPriceInfoDto;
    /**
     * Массив с информацией о дополнительных сервисах
     * @type {Array<AdditionalServiceInfoDto>}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    additionalServices: Array<AdditionalServiceInfoDto>;
    /**
     * Accommodation TimeZone
     * @type {string}
     * @memberof PreorderBookingDetailsInfoResponseDto
     */
    timeZone?: string;
}

/**
 * Check if a given object implements the PreorderBookingDetailsInfoResponseDto interface.
 */
export function instanceOfPreorderBookingDetailsInfoResponseDto(value: object): value is PreorderBookingDetailsInfoResponseDto {
    if (!('placementCodes' in value) || value['placementCodes'] === undefined) return false;
    if (!('propertyInfo' in value) || value['propertyInfo'] === undefined) return false;
    if (!('bookingInfo' in value) || value['bookingInfo'] === undefined) return false;
    if (!('roomInfo' in value) || value['roomInfo'] === undefined) return false;
    if (!('priceInfo' in value) || value['priceInfo'] === undefined) return false;
    if (!('additionalServices' in value) || value['additionalServices'] === undefined) return false;
    return true;
}

export function PreorderBookingDetailsInfoResponseDtoFromJSON(json: any): PreorderBookingDetailsInfoResponseDto {
    return PreorderBookingDetailsInfoResponseDtoFromJSONTyped(json, false);
}

export function PreorderBookingDetailsInfoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreorderBookingDetailsInfoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contactInfo': json['contactInfo'] == null ? undefined : ContactsInfoModelFromJSON(json['contactInfo']),
        'placementCodes': json['placementCodes'],
        'propertyInfo': PreorderPropertyInfoDtoFromJSON(json['propertyInfo']),
        'bookingInfo': TravelineBookingStayDatesDtoFromJSON(json['bookingInfo']),
        'roomInfo': PreorderRoomInfoDtoFromJSON(json['roomInfo']),
        'priceInfo': PreorderPriceInfoDtoFromJSON(json['priceInfo']),
        'additionalServices': ((json['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoFromJSON)),
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}

  export function PreorderBookingDetailsInfoResponseDtoToJSON(json: any): PreorderBookingDetailsInfoResponseDto {
      return PreorderBookingDetailsInfoResponseDtoToJSONTyped(json, false);
  }

  export function PreorderBookingDetailsInfoResponseDtoToJSONTyped(value?: PreorderBookingDetailsInfoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactInfo': ContactsInfoModelToJSON(value['contactInfo']),
        'placementCodes': value['placementCodes'],
        'propertyInfo': PreorderPropertyInfoDtoToJSON(value['propertyInfo']),
        'bookingInfo': TravelineBookingStayDatesDtoToJSON(value['bookingInfo']),
        'roomInfo': PreorderRoomInfoDtoToJSON(value['roomInfo']),
        'priceInfo': PreorderPriceInfoDtoToJSON(value['priceInfo']),
        'additionalServices': ((value['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoToJSON)),
        'timeZone': value['timeZone'],
    };
}

